// extracted by mini-css-extract-plugin
module.exports = {"badge":"LiveBadge_badge__MWCKe"};